import angular from 'angular'

import sceneService from 'common/scene.service.js'
import history from 'components/history'
import ColorService from 'common/color.service'

import component from './scene-edit.component'

export default angular.module('scene-edit', [
  sceneService,
  history,
  ColorService
])
  .component('sceneEdit', component)
